var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn dm-decline-book",
        class: { "is-declined": _vm.isDeclined },
        attrs: { "data-bs-toggle": "tooltip", title: _vm.buttonText },
        on: {
          click: function($event) {
            return _vm.toggleFavourite()
          }
        }
      },
      [_c("svg-icon", { attrs: { icon: "ban" } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }